angular.module(NgAppName).component('crContactV2PreDev', {
  templateUrl: 'crContactV2PreDev.html',
  bindings: {
    buildingToken: '@',
    target: '<',
    user: '<',
    rpc: '@'
  },
  controller: ['$scope', '$timeout', '$interval', '$window', "$cookies", "$rootScope", 'PubSub', '$element', '$document', 'crResourcesService',
    function($scope, $timeout, $interval, $window, $cookies, $rootScope, PubSub, $element, $document, crResourcesService) {
      let ctrl = this;
      let popupChild;
      this.formData = {
        isLoading: false
      };
      this.submitted = false;

      this.uniqueId = $scope.$id;

      this.submitForm = (form) => {
        this.formData.isLoading = true;
        if (form.$valid) {     
              window.crRecaptcha.execute(() => {
                  this.submitFormLogic(form);
              });
          } else {
              form.$setSubmitted();
              this.formData.isLoading = false;
          }
      };


      this.submitFormLogic = function($form) {
        var url = this.rpc;
        var _postData = this.createData();
        var form = $form;

        this.emptyMessage = false;
        if (!!form.showMessage && !_postData.msg) {
          this.emptyMessage = true;
        }
        var crDataPromise = crResourcesService.post(url, _postData);

        // this.formData.isLoading = true;
        if (form) {
          form.globalErrors = [];
        }

        crDataPromise.then((data) => {
          if (data['RPCFormReusableContact_FORMSUMMARY'][0].status) {
            window.crRecaptcha.setSuccessState(true);

            var now = new Date(),
              exp = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 5); // set the expiration to 5 days ahead
            $cookies.put('exitPopupShown', 'true', { expires: exp });
            this.formData.isLoading = false;
            this.successMessage = data['RPCFormReusableContact_FORMSUMMARY'][0].message;
            this.submitted = true;
            this.isSuccessMessage = true;
          } else {
            window.crRecaptcha.setSuccessState(false);

            if (form) {
              let specificError = false;
              if (data["RPCFormReusableContact_email"]) {
                var error = data["RPCFormReusableContact_email"];
                if (error[0].indexOf("valid") > 0) {
                  form.email.$setValidity("pattern", false);
                } else {
                  // may be another/generic message, but for now it's the same
                  form.email.$setValidity("pattern", false);
                }
                specificError = true;
              }

              if (data["RPCFormReusableContact_dayphone"]) {
                var error = data["RPCFormReusableContact_dayphone"];
                if (error[0].indexOf("already exist") > 0 || error[0].indexOf("already in use") > 0 ) {
                  form.phone.$setValidity("phoneExist", false);
                } else if (error[0].indexOf("too short") > 0) { // phone too short
                  form.phone.$setValidity("phoneShort", false);
                } else { // twilio phone error
                  form.phone.$setValidity("pattern", false);
                }
                specificError = true;
              }

              if (data["RPCFormReusableContact_recaptcha"]) {
                form.globalErrors.push(this.errorMessages.recaptcha);
              } else if (!specificError) {
                form.globalErrors.push(this.errorMessages.generic);
              }
            }
            this.formData.isLoading = false;
          }
        }).finally(() => {
          this.formData.isLoading = false;
          delete this.user.listings;
        });
      };

      this.createData = function() {
        var data = {};
        data.name = this.user.name;
        data.email = this.user.email;
        data.subscribe = this.user.subscribe;
        data.dayphone = this.user.phone;
        data.msg = this.user.message && this.user.message != 'Also add any questions or message' ? this.user.message : '';
        data.token = this.buildingToken;
        if (this.popup) {
          data.popup = this.popup;
        }
        if (this.popupName) {
          data.popupName = this.popupName;
        }
        if (this.source) {
          data.source = this.source;
        }
        if (this.version) {
          data.version = this.version;
        }
        if (this.user.listings) {
          data.listings = this.user.listings;
        }
        if (this.user.bedrooms) {
          data.bedrooms = this.user.bedrooms;
        }
        if (this.user.openhouse) {
          data.openhouse = this.user.openhouse;
        }
        if (this.headerVersion) {
          data.headerVersion = this.headerVersion;
        }
        if (this.collectionId) {
          data.collectionId = this.collectionId;
        }

        if (this.user.buyerRenter) {
          let buyerRenter = 0;
          if (this.user.buyerRenter.buyer) {
            if (this.user.buyerRenter.renter) {
              buyerRenter = 3;
            } else {
              buyerRenter = 1;
            }
          } else if (this.user.buyerRenter.renter) {
            buyerRenter = 2;
          }
          data.buyerRenter = buyerRenter;
        }

        if (this.user.interestedInOffMarketListings) {
          data.interestedInOffMarketListings = this.user.interestedInOffMarketListings;
        }

        data.reCaptchaTokens =  window.crRecaptcha.getTokens();

        return data;
      };

      // that's for popup close/open
      $rootScope.$on('resetContactV2Form', function () {
        ctrl.submitted = false;
        ctrl.isSuccessMessage = false;
        ctrl.successMessage = false;
        $scope.$apply(); // Ensure UI updates
      });

    }
  ]
});
